import React from 'react';
import { RealUserOnly } from '../pages/admin/RealUserOnly.js';
import { IconButton } from './IconButton.js';
import { IconMoreVertical } from './QuirkIcons/index.js';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import { useIonPopover } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { User } from 'model';
import { BlockUser } from './BlockUser.js';

type MenuPopupProps = { hide: () => void; user?: User; onHideUser: () => void; onUnHideUser: () => void };

const MenuPopup: React.FC<MenuPopupProps> = ({ user, onHideUser, onUnHideUser, hide }) => {
	return (
		<>
			<div className={sharedStyles.popMenu}>
				{user && (
					<BlockUser
						userToBlock={user}
						type="menu"
						onBlockUser={onHideUser}
						onUnBlockUser={onUnHideUser}
						action={hide}
					/>
				)}
			</div>
		</>
	);
};

export type ConversationMenuProps = {
	user?: User;
};

export const ConversationMenu: React.FC<ConversationMenuProps> = ({ user }) => {
	const history = useHistory();
	const [show, hide] = useIonPopover(
		<MenuPopup
			user={user}
			hide={() => hide()}
			onHideUser={() => {
				hide();
				history.push('/main/messages');
			}}
			onUnHideUser={() => {
				hide();
			}}
		/>,
		{}
	);
	return (
		<RealUserOnly>
			<div className={sharedStyles.menuIconContainer} data-testid={`ConversationMenu-${''}`}>
				<IconButton
					icon={<IconMoreVertical color={'var(--neutral900)'} />}
					onClick={(event: Event) => show({ event })}
				/>
			</div>
		</RealUserOnly>
	);
};
